const category = 'AppSpecificDeveloper';

const cards = [
    {
        name: "Investigation",
        id: "Investigation",
        fields: [
            [
                {
                    id: "InvestigationHeaderCriteria",
                    listItems: [
                        "Name",
                        "Label",
                        "VisibleWhenRef",
                    ],
                },
            ],
        ],
    },
];

export { cards, category };